import styled from "@emotion/styled";
import {Slider, TextField} from "@mui/material";

export const NumericInput = styled(TextField)`
  min-width: 200px;
`;

export const StyledSlider = styled(Slider)`
    max-width: 90%;
`;